import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accountService } from "../../services/enhancedCrudService";
import { toast } from "react-toastify";

const AccountLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    identifier: "",
    pin: "",
    device_id: "",
  });
  const generateUUID = () => {
    if (crypto.randomUUID) {
      let id = localStorage.getItem("uniqueId");
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("uniqueId", id);
      }
      return id;
    } else {
      let id = localStorage.getItem("uniqueId");
      if (!id) {
        id = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
        localStorage.setItem("uniqueId", id);
      }
      return id;
    }
  };
  useEffect(() => {
    const deviceId = generateUUID();
    setFormData(prev => ({
      ...prev,
      device_id: deviceId
    }));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await accountService.login(formData);
      if (response.accessToken) {
        sessionStorage.setItem("accessToken", response.accessToken);
        sessionStorage.setItem("refreshToken", response.refreshToken);
        sessionStorage.setItem("user", JSON.stringify(response.user));
        toast.success("Login successful!");
        navigate("/dashboard");
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="col-md-6 col-lg-4">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Login</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="identifier"
                  value={formData.identifier}
                  onChange={handleInputChange}
                  placeholder="Enter email"
                  maxLength="100"
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  title="Please enter a valid email address"
                  required
                />
              </div>
              <div className="form-group">
                <label>PIN</label>
                <input
                  type="password"
                  className="form-control"
                  name="pin"
                  value={formData.pin}
                  onChange={handleInputChange}
                  placeholder="Enter your PIN"
                  maxLength="4"
                  pattern="[0-9]{4,6}"
                  title="PIN should be 4 digits"
                  required
                />
                <small className="form-text text-muted">
                  Enter your 4 digit PIN
                </small>
              </div>
              <div className="form-group text-end">
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountLogin;
